import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Header */}
      <div className="bg-slate-900 text-white pt-36 pb-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1599995903128-531fc7fb694b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc3MDQzODUyNXww&ixlib=rb-4.1.0&q=85')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-display font-bold uppercase tracking-wide mb-4">About Us</h1>
          <p className="text-xl text-gray-300 max-w-2xl font-light">
            Foresight for Reliability: Predict. Prevent. Perform.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        {/* Mission/Vision */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
              <div>
                <span className="text-gold font-bold uppercase tracking-widest text-sm mb-2 block">Our DNA</span>
                <h2 className="text-4xl font-display font-bold text-foreground mb-6">Building Industrial Resilience</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Yantraksh Projects Pvt. Ltd. is a premier execution specialist serving the Mining and Steel sectors with integrated civil, mechanical, electrical, maintenance and regulatory solutions. We provide end-to-end project support — from site preparation and clearances to daily plant operations and maintenance.
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  By unifying every discipline under one roof, we help industries reduce downtime, improve operational efficiency and accelerate project execution. We don't just fix machines; we optimize entire asset lifecycles.
                </p>
              </div>
              <div className="grid grid-cols-1 gap-8">
                <div className="bg-gray-50 p-8 border-l-4 border-gold">
                  <h3 className="text-xl font-display font-bold text-foreground mb-3">Our Vision</h3>
                  <p className="text-gray-600 text-sm">To be the most trusted industrial execution partner in the Indian Mining and Metals sector by setting benchmarks in reliability, safety and engineering excellence.</p>
                </div>
                <div className="bg-gray-50 p-8 border-l-4 border-primary">
                  <h3 className="text-xl font-display font-bold text-foreground mb-3">Our Mission</h3>
                  <p className="text-gray-600 text-sm">Deliver integrated industrial projects on time and within budget through unified expertise, skilled manpower, rigorous planning and uncompromising safety standards.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-slate-100">
           <div className="container mx-auto px-4">
              <h2 className="text-3xl font-display font-bold text-center mb-12">Core Values</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                  { title: "Reliability", desc: "We deliver on our promises, ensuring your operations never stop." },
                  { title: "Safety First", desc: "Zero compromise on safety standards for our people and your plant." },
                  { title: "Innovation", desc: "Leveraging technology for predictive insights and efficiency." }
                ].map((val, idx) => (
                  <div key={idx} className="bg-white p-8 shadow-sm hover:shadow-md transition-shadow">
                    <h3 className="text-xl font-display font-bold text-primary mb-3">{val.title}</h3>
                    <p className="text-gray-600 text-sm">{val.desc}</p>
                  </div>
                ))}
              </div>
           </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-primary text-white text-center">
          <div className="container mx-auto px-4">
             <h2 className="text-3xl font-display font-bold mb-6">Join Our Journey</h2>
             <p className="max-w-2xl mx-auto text-blue-100 mb-8">Whether you are looking for a partner for your next greenfield project or need expert O&M support, we are here.</p>
             <Button variant="outline" className="border-white text-white hover:bg-white hover:text-primary rounded-none px-8 py-6 uppercase tracking-widest bg-transparent" asChild>
                <Link to="/contact">Contact Us</Link>
             </Button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
